<template>
  <div class="not-found-page flex justify-content-center align-items-center bg-f">
    <div class="animation-box relative">
      <div class="tips-box">
        <div class="img-box flex align-items-center justify-content-center">
          <img src="@cdn?951bdcb98f77" alt="" />
        </div>
        <div class="fs15 text-align-center mt10 mb20" style="color: #4b5e7b">没找到您要访问的页面</div>
        <div class="flex align-items-center justify-content-center">
          <div class="add-trace-btn-box fs15 font-weight-500">
            <el-button type="primary" @click="goHome">回到首页</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  methods: {
    goHome() {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found-page {
  width: 100vw;
  height: 100vh;

  .animation-box {
    width: 560px;
  }

  .tips-box {
    position: absolute;
    right: 0;
    bottom: -30px;
    left: 0;
    margin: auto;
  }

  .img-box {
    img {
      display: block;
      width: 224px;
      height: auto;
    }
  }

  .go-home {
    width: 118px;
    height: 30px;
    color: #ff7752;
    border: 1px solid #ff8b6b;
    border-radius: 2px;
  }
}
</style>
